
/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
import CryptoJs from 'crypto-js'
export const userInfoFunc=(data)=>{
    let companyCode = data?data.companyCode:null
    return companyCode
}
export const guid=(id,type)=>{
    // type  2:Web端; 1:后台管理系统;
    if(!id || id ==undefined){
        id = ''
    }
    var getuid = '00000000' + id
    getuid = getuid.substring(getuid.length - 8,getuid.length)
    getuid = getuid + ':' + type
    console.log(getuid)
    getuid = CryptoJs.enc.Utf8.parse(getuid)
    return CryptoJs.enc.Base64.stringify(getuid)
}
